import { render, staticRenderFns } from "./nuevoCurso.vue?vue&type=template&id=c6fc4506"
import script from "./nuevoCurso.vue?vue&type=script&lang=js"
export * from "./nuevoCurso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports